import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Observable, firstValueFrom, of, EMPTY } from 'rxjs';

import { CodeInputComponent } from 'angular-code-input';
import { HelperService } from '../../core/services/helper.service';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { AuthService } from 'libs/pnp-services/src/lib/auth/auth.service';
import { AuthErrors, AuthErrorService, PnpUserService } from '@pn-plus/pnp-services';
import { ITokenInfo } from 'libs/pnp-services/src/lib/api/_models/pnp-token-info.model';
import { LoginService } from '../../core/services/login.service';

@Component({
    selector: 'pnl-set-pin',
    templateUrl: './set-pin.component.html',
    styleUrls: ['./set-pin.component.scss'],
})
export class SetPinComponent implements OnInit {
    @ViewChild('codeInput') codeInput!: CodeInputComponent;
    @ViewChild('codeInput', { read: ElementRef, static: false }) codeInputRef: ElementRef<HTMLElement>;

    public firstPin = '';
    public secondPin = '';
    public isLoading = false;
    public activeError: number;


    constructor(
        private helperService: HelperService,
        private authService: AuthService,
        private loginService: LoginService,
        private pnpUserService: PnpUserService,
        private authErrorService: AuthErrorService,
        ) {}

    ngOnInit(): void {

    }

    async onCodeCompleted(pincode: string) {
        if(pincode.length < 4) {
            this.codeInput.reset();
            this.activeError = AuthErrors.CodeNotValid;
            return;
        }

        if (!this.firstPin) {
            this.processFirstPin(pincode);
        } else {
            this.processSecondPin(pincode);
            if(this.activeError === AuthErrors.Success) {
                this.setBusy(true);
                await firstValueFrom(this.setPin(pincode));
                await firstValueFrom(this.updateHasPin());
                const authModel = this.updateRegistration();
                if(this.activeError === AuthErrors.Success) {
                    this.loginService.navigateRegistration(authModel);
                }
                this.setBusy(false);
            } else {
                this.codeInput.reset();
            }
        }
    }

    updateRegistration() {
        const authModel = this.authService.getAuthModel();
        
        if(this.activeError !== AuthErrors.Success){
            return authModel;
        }
        
        if(authModel.registrationResponse) {
            authModel.registrationResponse.hasPin = true;
        }
        
        this.authService.updateAuthModel(authModel);
        return authModel;
    }

    processFirstPin(pincode: string) {
        if(this.helperService.checkForSameDigits(pincode)) {
            this.activeError = AuthErrors.SameDigitsError; // this.errors.sameDigitsError;
        } else {
            this.activeError = AuthErrors.Success;
            this.firstPin = pincode;
        }
        this.codeInput.reset();
    }

    processSecondPin(pincode: string) {
        this.secondPin = pincode;

        if(this.secondPin !== this.firstPin) {
            //error = this.errors.pinCodesMismatchError;
            this.activeError = AuthErrors.PinCodesMismatchError;
        }
    }

    setPin(pin: string): Observable<any> {
        if(this.activeError !== AuthErrors.Success){
            return EMPTY;
        }
        return this.pnpUserService.putPin(pin)
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.activeError = this.authErrorService.getErrorByType(errorResponse.error.type);
                    return EMPTY;
                }),
                map((response: ITokenInfo) => {
                    return response;
                })
            );
    }

    updateHasPin(): Observable<any> {
        if(this.activeError !== AuthErrors.Success){
            return EMPTY;
        }
        return this.pnpUserService.putHasPin()
            .pipe(
                catchError((errorResponse: HttpErrorResponse) => {
                    this.activeError = this.authErrorService.getErrorByType(errorResponse.error.type);
                    return EMPTY;
                }),
                map((response) => {
                    return response;
                })
            );
    }

    onCodeChanged(event: any) {
        this.activeError = AuthErrors.Success;
        this.helperService.showPreviousCodeInput(event);
    }

    onGoBack() {
        this.firstPin = '';
        this.secondPin = '';
        this.activeError = AuthErrors.Success;
        this.codeInput.reset();
    }

    setBusy(flag: boolean): void {
        this.isLoading = flag;
    }
}
